var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroid = function SvgAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87C527",
    fillRule: "evenodd",
    d: "M9.444 2.913A5.2 5.2 0 0 1 12 2.25c.928 0 1.8.24 2.556.663l.554-.553a.375.375 0 0 1 .53.53l-.444.444A5.24 5.24 0 0 1 17.25 7.5H6.75c0-1.697.805-3.206 2.054-4.166L8.36 2.89a.375.375 0 1 1 .53-.53zM10.5 5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C527",
    d: "M3.75 9.375a1.125 1.125 0 0 1 2.25 0v4.5a1.125 1.125 0 0 1-2.25 0zM9 18v2.625a1.125 1.125 0 0 0 2.25 0V18h1.5v2.625a1.125 1.125 0 0 0 2.25 0V18h.75a1.5 1.5 0 0 0 1.5-1.5V8.25H6.75v8.25a1.5 1.5 0 0 0 1.5 1.5zM18 9.375a1.125 1.125 0 0 1 2.25 0v4.5a1.125 1.125 0 0 1-2.25 0z"
  })));
};
export default SvgAndroid;